import { compose } from "redux";
import { connect } from "react-redux";
const mapStateToProps = (state) => ({
  campaigns: state.createNewCompany.campaigns,
});

const withConnect = connect(mapStateToProps);
export const enhance = compose(withConnect);
